export const UPDATE_INSTRUCTOR_DETAIL_REQUEST =
  "UPDATE_INSTRUCTOR_DETAIL_REQUEST";
export const UPDATE_INSTRUCTOR_DETAIL_SUCCESS =
  "UPDATE_INSTRUCTOR_DETAIL_SUCCESS";
export const UPDATE_INSTRUCTOR_DETAIL_FAILURE =
  "UPDATE_INSTRUCTOR_DETAIL_FAILURE";

export const GET_INSTRUCTOR_DETAIL_REQUEST = "GET_INSTRUCTOR_DETAIL_REQUEST";
export const GET_INSTRUCTOR_DETAIL_SUCCESS = "GET_INSTRUCTOR_DETAIL_SUCCESS";
export const GET_INSTRUCTOR_DETAIL_FAILURE = "GET_INSTRUCTOR_DETAIL_FAILURE";

export const GET_INSTRUCTOR_WITH_COURSES_REQUEST =
  "GET_INSTRUCTOR_WITH_COURSES_REQUEST";
export const GET_INSTRUCTOR_WITH_COURSES_SUCCESS =
  "GET_INSTRUCTOR_WITH_COURSES_SUCCESS";
export const GET_INSTRUCTOR_WITH_COURSES_FAILURE =
  "GET_INSTRUCTOR_WITH_COURSES_FAILURE";

export const GET_CURRENT_INSTRUCTOR_REQUEST = "GET_CURRENT_INSTRUCTOR_REQUEST";
export const GET_CURRENT_INSTRUCTOR_SUCCESS = "GET_CURRENT_INSTRUCTOR_SUCCESS";
export const GET_CURRENT_INSTRUCTOR_FAILURE = "GET_CURRENT_INSTRUCTOR_FAILURE";

export const GET_MY_STUDENTS_REQUEST = "GET_MY_STUDENTS_REQUEST";
export const GET_MY_STUDENTS_SUCCESS = "GET_MY_STUDENTS_SUCCESS";
export const GET_MY_STUDENTS_FAILURE = "GET_MY_STUDENTS_FAILURE";

export const GET_INSTRUCTORS_REQUEST = "GET_INSTRUCTORS_REQUEST";
export const GET_INSTRUCTORS_SUCCESS = "GET_INSTRUCTORS_SUCCESS";
export const GET_INSTRUCTORS_FAILURE = "GET_INSTRUCTORS_FAILURE";

export const RESET_ALL_ACTIONS = "RESET_ALL_ACTIONS";
